import { render, staticRenderFns } from "./section3.vue?vue&type=template&id=5765a5ca&scoped=true"
import script from "./section3.vue?vue&type=script&lang=js"
export * from "./section3.vue?vue&type=script&lang=js"
import style0 from "./section3.vue?vue&type=style&index=0&id=5765a5ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5765a5ca",
  null
  
)

export default component.exports